import { ITeams } from "../../types/types";
import { clipText, CompactTableColumn } from "./compactTableColumn";

export const TEAMS_TABLE_COLUMNS: CompactTableColumn<ITeams>[] = [
  { id: "id", header: "ID", sortKey: "id", width: "8%", render: (team) => team.id },
  { id: "name", header: "Nimi", sortKey: "name", width: "28%", render: (team) => team.name },
  {
    id: "type",
    header: "Liiga",
    sortKey: "type",
    width: "16%",
    render: (team) => team.type || "—",
  },
  {
    id: "website",
    header: "Verkkosivu",
    sortKey: "website",
    width: "48%",
    render: (team) => clipText(team.website, 48),
  },
];
